import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { HttpClient } from '../../../services/http.service';

@Injectable()
export class ImportFeedCommerceResolve {

  constructor(private http: HttpClient) { }

  resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
    // return this.http.post('Import.realization_commerce_get', {'setting_id': route.parent.params['id']});
    return this.http.post('Import.realization_commerce_get', {'setting_id': route.parent.params['id']});
  }
}
